import React from 'react';
import Loading from '../components/atoms/Loading';
import CustomPagination from '../components/atoms/customPagination';
import Modal from '../components/atoms/Modal';
import ToastContainer from '../components/atoms/Toast';
import ComplaintTableToolbar from '../components/molecules/ComplaintTableToolbar';
import ComplaintTableGrid from '../components/organisms/ComplaintTableGrid';
import useComplaintManagementDetails from '../hooks/useComplaintManagementDetails';

export default function ComplaintManagementDetails() {
  const complaint = useComplaintManagementDetails();

  return (
    <section className="ca-complaint-table" aria-label="Complaint records">
      <ComplaintTableToolbar
        selectedStatus={complaint.selectedStatus}
        statusNames={complaint.statusNames}
        updatedAtSortOldest={complaint.selectedUpdatedAtSort === 'asc'}
        onStatusChange={complaint.onStatusChange}
        onSortChange={complaint.onSortChange}
        onNewComplaint={complaint.onNewComplaint}
        onDownloadReport={complaint.onDownloadReport}
        isDownloadingReport={complaint.isDownloadingReport}
        complaintTypeId={complaint.complaintTypeId}
        canCreateComplaint={complaint.canCreateComplaint}
        isComplaintTypeActive={complaint.isComplaintTypeActive}
      />

      {complaint.error ? <p className="ca-body">{complaint.error}</p> : null}
      {complaint.downloadError ? <p className="ca-body">{complaint.downloadError}</p> : null}
      {complaint.statusUpdateError ? (
        <div className="ca-validation-toast" role="alert">{complaint.statusUpdateError}</div>
      ) : null}
      {complaint.showLoading ? (
        <Loading text="Loading complaints" />
      ) : (
        <ComplaintTableGrid {...complaint.tableProps} />
      )}
      {complaint.paginationProps.hasRows ? <CustomPagination {...complaint.paginationProps} /> : null}

      {complaint.pendingChange ? (
        <Modal
          open
          title={
            complaint.pendingChange.type === 'status'
              ? `Change status from ${complaint.pendingChange.fromLabel} to ${complaint.pendingChange.toLabel}?`
              : `Change escalation from ${complaint.pendingChange.fromLabel} to ${complaint.pendingChange.toLabel}?`
          }
          onPrimary={complaint.onConfirmPendingChange}
          onSecondary={complaint.onCancelPendingChange}
          primaryLabel="Save"
          secondaryLabel="Cancel"
        >
          <label className="ca-confirm-modal__label" htmlFor="ca-remark-input">Remark (optional)</label>
          <textarea
            id="ca-remark-input"
            className="ca-confirm-modal__textarea"
            value={complaint.remarkDraft}
            onChange={(event) => complaint.onRemarkDraftChange(event.target.value)}
            placeholder="Add a remark (optional)"
          />
        </Modal>
      ) : null}

      <ToastContainer toasts={complaint.toasts} onDismiss={complaint.onDismissToast} />
    </section>
  );
}